import * as React from 'react';
import { Button, Badge, Popover, Box, Typography, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAppSelector } from '../../app/hooks';
import { User } from '../../sdk/model';
import { userApi } from '../../adapters/APIExporter';

interface ReactionEmojiProps {
  emoji: string,
  userList: Set<string>,
  addReaction: Function,
  removeReaction: Function
}

function ReactionEmoji(props: ReactionEmojiProps) {
  const theme = useTheme();
  const user = useAppSelector((state) => state.user);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [userInfo, setUserInfo] = React.useState<User[]>([]);
  
  React.useEffect(() => {
    if (anchorEl) {
      userApi.getUsersByIds(props.userList).then(response => setUserInfo(response.data));
    }
  }, [anchorEl]);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  
  let onClick;
  let backgroundColor;
  if (props.userList.includes(user.id!)) {
    onClick = () => props.removeReaction(props.emoji);
    backgroundColor = theme.palette.primary.main + 20;
  } else {
    onClick = () => props.addReaction(props.emoji);
    backgroundColor = theme.palette.background.default;
  }
  return <React.Fragment>
    <Button sx={{ border: `2px solid ${theme.palette.primary.main}20`, backgroundColor: backgroundColor,  borderRadius: '100%', minWidth: '1px'}} onClick={onClick}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}>
      <Badge badgeContent={props.userList.length} color="primary" anchorOrigin={{ vertical: 'bottom', horizontal: 'right'}} sx={{ "& .MuiBadge-badge": {height: '16px', width: '16px', minWidth: '16px'}}}>  
        <span role="img">{props.emoji}</span>
      </Badge>
    </Button>
    <Popover
      id="mouse-over-popover"
      sx={{ pointerEvents: 'none' }}
      open={!!anchorEl}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      {userInfo.length === 0 ? 'Loading...' :
        userInfo.map(user => 
          <Box key={user.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end' }}>
            <Typography variant="body2">
              {user.username}
            </Typography>
            {user.picture && (
              <Avatar 
                src={user.picture} 
                sx={{ width: 24, height: 24 }}
              />
            )}
          </Box>
        )
      }
    </Popover>
  </React.Fragment>
}

export default ReactionEmoji;
